import React from 'react';
import './kovin.css';

const DrRajuKaiti = () => {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">International</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/dr raju.jpg" alt="Dr Raju Kaiti" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Dr. Raju Kaiti</h3>
              <div className="name-underline"></div>
            </div>
          </div>

          <div className="bio-container">
            <p className="bio">


Dr. Raju Kaiti has always been an excellent academic achiever throughout his educational journey, 
not only he was a merit scholarship holder from Institute of Medicine (IOM) during his bachelors, 
he also topped university with flying colors.He was a gold medalist in his post-graduation from Amity University, 
India. Dr. Kaiti, at present shoulders multiple responsibilities; head of contact lens and pediatric refraction at 
Nepal Eye Hospital (NEH). Dr. Kaiti is reviewer in many PubMed indexed international journals. And so far, he has been extra-ordinarily successful in bracing his responsibilities with great passion and virtue.
<br /> <br />

Dr. Kaiti's contributions in field of research, he has published about four dozen of scientific papers in national 
and international publications. Embarking his presence on international stage, he is a committed editor/reviewer of 
dozens of international publications. Moreover, he is an advocate for research works, encouraging the new generations 
f optometrist to indulge in eye-health research for the better of eye health in Nepal.He has and continues to take 
an active role in the success of all of the students he oversees.
<br /><br />    

            </p>
            <div className="bio-decoration"></div>
          </div>
        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
          <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now<span>&rarr;</span> <a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default DrRajuKaiti